import React from 'react';
import sanitizeHtml from 'sanitize-html';
import { CardForEventsData } from '@yme/molecules/cards/card-for-events';
import { useTranslation } from '@yme/services/i18n';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { INDENT } from '@yme/tokens/sizes';
import { SELF } from '@yme/utils/constants';
import { regExpNewLine } from '@yme/utils/regEx';
import { ContentGridSkeleton } from './ContentGridSkeleton';
import { HIGHLIGHT_TEXT_ID } from './constants';
import { getCaption, highlightText, modifyText } from './helpers';
export function ContentGrid({ isRightToLeft, isLoaded, contentItems, countLineVisible = 1, category, query = '', symbolsInLine, language, autoCorrectQueryResult, }) {
    const { t } = useTranslation();
    const queryHighlight = autoCorrectQueryResult || query;
    if (!isLoaded) {
        return React.createElement(ContentGridSkeleton, null);
    }
    return (React.createElement(React.Fragment, null, contentItems.map(({ item_id, url, description, title, date, date_to }, index) => {
        const plainDescription = sanitizeHtml(description, {
            allowedTags: [],
        }).replace(regExpNewLine, '');
        const modifiedDescription = modifyText(plainDescription, queryHighlight, symbolsInLine, countLineVisible);
        const descriptionText = highlightText(modifiedDescription, queryHighlight);
        const titleText = descriptionText.includes(HIGHLIGHT_TEXT_ID)
            ? title
            : highlightText(title, queryHighlight);
        return (React.createElement(FlexWrapper, { mt: index === 0 ? INDENT.xs : INDENT.xl, key: item_id, flexDirection: "column" },
            React.createElement(CardForEventsData, { isSearchPage: true, caption: getCaption(Number(date), Number(date_to), category, language), toRoute: url, labelLink: t('common_readMore_link'), isRightToLeft: isRightToLeft, linkTarget: SELF, link: url, title: titleText, plainTitle: title, description: descriptionText, countLineVisible: countLineVisible })));
    })));
}
